import { render, staticRenderFns } from "./UserInviteModal.vue?vue&type=template&id=679ae14b&scoped=true"
import script from "./UserInviteModal.vue?vue&type=script&lang=js"
export * from "./UserInviteModal.vue?vue&type=script&lang=js"
import style0 from "./UserInviteModal.vue?vue&type=style&index=0&id=679ae14b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ae14b",
  null
  
)

export default component.exports